// extracted by mini-css-extract-plugin
var _1 = "TestRankingItem_icon__30399";
export { _1 as "icon" }
